import styled from 'styled-components';

export const SelectContainer = styled.div`
  display: flex;
  flex-direction: column;

  label {
    font-style: normal;
    font-weight: normal;
    font-size: 0.9rem;
    color: var(--grey-100);
  }

  small {
    color:#FF6565;
    font-size: 13.5px;
    font-family: IBM Plex Sans;
    line-height: 12px;
    margin-top: 0.5rem;
  }
`

export const Select = styled.select`
  border-radius: 5px;
  padding: 0rem 1rem;
  margin: auto;
  margin-top: 12px;
  background-color: var(--black-100);
  width: 100%;
  padding: 1rem;
  height: 3.2rem;
  color: white;
  border: none;
  &:focus {
    outline: 0;
  }
  font-size: 0.95rem;
  font-family: Inter, sans-serif;
  > option {
    font-size: 0.87rem;
    font-family: Inter, sans-serif;
  }
`